import { useSelector } from 'react-redux'

import type { AppState } from '@/types'

/**
 * True while the AI assistant is actively working on the current project.
 * Mirrors the canvas-level flag that already drives the `--artboard-disabled`
 * dim, so the progress frame, disabled controls and blocking toasts all key off
 * the same signal (OCT-4826).
 */
export const useAiGenerating = () =>
  useSelector<AppState, boolean>(({ artboard }) => artboard.aiGenerating)
